import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translationsConvertKey',
  standalone: true,
  pure: false, // Make impure so it updates when translations change
})
export class TranslationsConvertKeyPipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(
    value: string,
    prefix: string,
    keyOnly: boolean = false
  ): string {
    // Check if value is not a string or is empty
    if (!value || !prefix || typeof value !== 'string') {
      return value;
    }

    // Convert to snake_case and add prefix, then replace underscores with dots for nested keys
    let key = `${prefix}.${value.toLowerCase().replace(/[\s_]+/g, '_')}`;

    // If keyOnly is true, return just the key
    if (keyOnly) {
      return key;
    }

    // Retrieve the translated value using ngx-translate
    return this.translate.instant(key) || value;
  }
}
